const allPaySliptable = { data: [], loading: true };
const allPaySlipBatch = { data: [], loading: true };

export const GetAllPaySlipTable = (state = allPaySliptable, action) => {
  switch (action.type) {
    case "get_allpaysliptable":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllPaySlipBatchReducer = (state = allPaySlipBatch, action) => {
  switch (action.type) {
    case "get_allpayslipbatch":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
